// Dynamic backend URL configuration
// Uses environment variable for backend URL

const getBackendUrl = () => {
  // Always use environment variable - required for deployment
  if (!process.env.REACT_APP_BACKEND_URL) {
    throw new Error('REACT_APP_BACKEND_URL environment variable is required');
  }
  return process.env.REACT_APP_BACKEND_URL;
};

export const BACKEND_URL = getBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;
